<template>
    <v-dialog persistent v-model="show" max-width="500px">
        <v-card tile>
            <v-card-title class="py-0 pl-0 pr-2">
                <v-chip class="ma-2" color="primary darken-3" outlined pill>
                    <v-icon left> mdi-alert-octagram </v-icon>
                    <!-- Log Perubahan Versi Aplikasi -->
                    Fitur Baru di Aplikasi
                </v-chip>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-row
                class="mx-2"
                dense
                v-for="(info, i) in logItems"
                :key="i + 'info'"
            >
                <v-col cols="12">
                    <v-card outlined tile>
                        <v-simple-table>
                            <template v-slot:default>
                                <tbody>
                                    <tr>
                                        <td class="white--text blue-grey">
                                            Version : {{ info.app_version }}
                                        </td>
                                    </tr>
                                    <tr
                                        v-for="(item, i) in info.items"
                                        :key="i + 'log'"
                                    >
                                        <td>{{ item }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
            </v-row>
            <v-card-actions>
                <v-footer color="px-0 transparent" width="100%">
                    <v-layout>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="hide">
                            Jangan Tampilkan Lagi
                        </v-btn>
                    </v-layout>
                </v-footer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { log } from "@chenfengyuan/vue-qrcode";
export default {
    data() {
        return {
            key: null,
            sh: true
        };
    },

    computed: {
        show: {
            get() {
                let hideLog = localStorage.getItem("hideLog");
                if (hideLog) {
                    return false;
                }
                return this.sh;
            },
            set(nv) {
                this.sh = nv;
            }
        },

        logItems() {
            const logs = this.$store.state.app_info.logs;

            const latestUpdateLog = [logs[0]];

            return latestUpdateLog;
        }
    },

    methods: {
        hide() {
            this.show = false;
            localStorage.setItem("hideLog", true);
        }
    }
};
</script>

<style></style>
